<template>
    <div class="filter-container">
        <headline :saveSearch="saveSearch" @keywordChange="keywordChange" @newSearch="newSearch" ref="headline" :params="headLines"></headline>
        <div class="select-filter">
            <div class="select">
                <ul>
                    <li v-for="item in tabList" :key="item.key" @click="pageType = item.key" :class="{on: pageType == item.key}">{{item.title}}</li>
                    <!-- <li @click="pageType = 'file'" :class="{on: pageType == 'file'}">素材库检索</li>
                    <li @click="pageType = 'material'" :class="{on: pageType == 'material'}">线索库检索</li> -->
                </ul>
            </div>
            <indexFilter :keySearch="keySearch" v-if="list_search.length > 0" :type="0" :list_search="list_search" @filterData="getFilters" @searchKeywords="searchKeywords" />
        </div>
        <div :class="{'filter-content': true}">
            <div class="sort">
              <span :class="{active: s.selected}" v-for="(s, i) in sorts" @click="switchSort(s)" :key="i">
                {{s.title}}
                <img src="@assets/img/common/up.svg" alt="up" v-if="s.selected">
              </span>
            </div>
            <div class="listContent" v-if="!loading">
                <noMore v-if="!show_list"></noMore>
                <empty :mTop="30" v-else-if="empty" :msg="`暂无${empty}`" />
                <materialList @setIsSelectAll="setIsSelectAll" v-else-if="pageType=='file'" class="materialList" :mList="mList"></materialList>
                <clueList v-else class="clueList" :clueList='clueList'></clueList>
            </div>
            <skeleton v-show="waiting && pageType=='file'" mediaType="media"></skeleton>
            <skeleton v-show="waiting && pageType=='material'" mediaType="list"></skeleton>
            <pages v-if="page.pageIndex>1||!loading" :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
        </div>
        <div v-show="selectListNum > 0" :style="'width: calc(100vw)'" class="filter-content bottom">
            <div class="left-container">
                <div @click="selectAll" :class="{selectBtn: true,on: isSelectAll}"></div>
                <div @click="selectAll" class="selectWord">
                全选
                <span>（已选择{{selectListNum}}个素材）</span>
                </div>
                <div class="btn-container">
                <div v-click-outside="closeBottomBtn">
                    <span @click="showBottomBtn = !showBottomBtn">创建</span> 
                    <ul v-show="showBottomBtn">
                    <li v-show="$store.state.create.material" @click="navigateMaterial('material');showBottomBtn = false">
                        <span>上传线索</span>
                    </li>
                    <li v-show="$store.state.create.report" @click="navigateMaterial('report');showBottomBtn = false">
                        <span>创建报道</span>
                    </li>
                    <li v-show="$store.state.create.publish" @click="navigateMaterial('publish');showBottomBtn = false">
                        <span>创建发布</span>
                    </li>
                    <li v-show="$store.state.create.new_media" @click="navigateMaterial('new_media');showBottomBtn = false">
                        <span>新媒体发布</span>
                    </li>
                    </ul>
                </div>
                <div v-show="$store.state.quickEdit" @click="useDetail">选用</div>
                <div v-show="path != 'index'">删除</div>
                </div>
            </div>
            <div class="right-container">
                <p @click="cancelAll">取消选择</p>
            </div>
        </div>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import headline from '@components/headline';
import indexFilter from '@components/indexFilter';
import resourceHandles from "@components/resourceHandles";
import empty from "@components/empty";
import pushBox from "@components/pushBox";
import checkers from "@components/checkers";
import globalFilter from "@components/globalFilter";
import materialList from "@components/materialList";
import clueList from "@components/clueList/clueList";
import noMore from "@components/noMore";
import pages from "@components/pages";
import DatePicker from 'vue2-datepicker';
import skeleton from "@components/skeleton";
import store from "@common/store";
import vClickOutside from "v-click-outside";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        headline,
        indexFilter,
        resourceHandles,
        empty,
        pushBox,
        checkers,
        globalFilter,
        materialList,
        noMore,
        pages,
        clueList,
        DatePicker,
        skeleton
    },
    watch: {
        "$store.state.isSelectAll": function (e) {
            this.isSelectAll = e;
        },
        "$store.state.selectList": function (e) {
            this.selectList = e
            this.selectListNum = e.length
        },
        footLineGap(to) {
            this.bottomWidth = this.$refs.content.getBoundingClientRect().width + 'px'
        },
        pageType(to) {
            this.selectList = [];
            this.selectListNum = 0;
            // this.filterOptions = {};
            this.$set(this.page, "pageSize", to == "file" ? 24 : 10);
            this.$set(this.page, "pageIndex", 1);
            this.pageType = to;
            this.getList();
        }
    },
    data() {
        return {
            saveSearch: '',
            isAdvanced: false,
            firstShow: true,
            showBottomBtn: false,
            selectList: [],
            path: '',
            bottomWidth: '1105px',
            isSelectAll: false,
            footLineGap: 230,
            selectListNum: 0,
            search_keywords: '',
            headLines: {
                title: '',
                showLink: false,
                filter: true
            },
            loading: false,
            show_list: true,
            empty: '',
            tabList: [],
            mList: [],
            clueList: [],
            list_search: [],
            keySearch: {},
            pageType: 'file',
            waiting: false,
            page: {
                pageCount: 0,
                pageSize: 24,
                pageIndex: 1,
                total: 0
            },
            filterOptions: {},
            searchOptions: {},
            sorts: [
                {
                    title: "时间",
                    key: "time",
                    selected: true
                },
                {
                    title: "被推送",
                    key: "push_num",
                    selected: false
                }
            ]
        }
    },
    methods: {
        cancelAll() {
            this.isSelectAll = false;
            store.commit("setIsSelectAll", this.isSelectAll);
            store.commit("cancelSelect", new Date());
        },
        useDetail() {
            let id = [];
            this.selectList.forEach(el => {
                id.push(el.id)
            })
            id = id.join(',')
            let data = {
                file_ids: id
            };

            common.myFetch(apis.File_addquickfile, data).then(res => {
                if (res) {
                this.$toast("已成功加入选用素材");
                store.commit("setQuickEditNum", res.quick_edit_num);
                }
            });
        },
        closeBottomBtn() {
            this.showBottomBtn = false;
        },
        selectAll(e) {
            this.isSelectAll = !this.isSelectAll;
            store.commit("setIsSelectAll", this.isSelectAll);
        },
        async navigateMaterial(type) {
            let arr = [];
            let id = "";
            this.selectList.forEach(el => {
                arr.push(el.id);
            });
            if (arr.length > 0) {
                id = arr.join(",");
                if (type === "interview") {
                common.jump("/newInterview", true);
                } else if (type === "material") {
                let info = {
                    id: id,
                    push_to: type,
                    type: 0
                };
                common.myFetch(apis.File_filepush, info).then(r => {
                    if (r) {
                    common.jump(`/creatClue?t=0&d=${r.id}`, true);
                    }
                });
                } else if (type === "report") {
                const typeName = await this.$pageType();
                if (!typeName) return;
                let info = {
                    id: id,
                    push_to: type,
                    type: typeName
                };
                common.myFetch(apis.File_filepush, info).then(r => {
                    if (r) {
                    common.jump(`/creatReport?t=${typeName}&d=${r.id}`, true);
                    }
                });
                } else if (type === "publish") {
                const typeName = await this.$pageType("publish");
                if (!typeName) return;
                let info = {
                    id: id,
                    push_to: type,
                    type: typeName
                };
                common.myFetch(apis.File_filepush, info).then(r => {
                    if (r) {
                    common.jump(`/createPublish?t=${typeName}&d=${r.id}`, true);
                    }
                });
                } else if (type === "new_media") {
                const typeName = await this.$MediaPlatform();
                if (!typeName) return;
                let info = {
                    file_ids: id,
                    subject_type: 5,
                    subject_id: typeName
                };
                common.myFetch(apis.File_bind, info).then(r => {
                    if (r) {
                    common.jump(`/createMediaPublish?d=${typeName}`, true);
                    }
                });
                }
            }
        },
        setSelectList(e) {
            this.selectListNum = e.length
        },
        searchKeywords(e) {
            console.log(e)
            if(this.isAdvanced){
                this.saveSearch = e
            }
            let arr = JSON.parse(e)
            if(arr.in.length > 0){
                let keySearch = {};
                let search_keywords = {};
                let search_keywordsIn = arr.in
                let search_keywordsOut = arr.out
                let search_keywordsIn1 = []
                let search_keywordsOut1 = []
                // search_keywordsIn = search_keywordsIn.split(',')
                // search_keywordsOut = search_keywordsOut.split(',')
                search_keywordsIn.forEach(el => {
                    search_keywordsIn1.push(el.key_words)
                })
                search_keywordsOut.forEach(el => {
                    search_keywordsOut1.push(el)
                })
                keySearch.in = search_keywordsIn
                keySearch.out = search_keywordsOut
                console.log(keySearch)
                
                this.keySearch = keySearch;
                search_keywords.in = search_keywordsIn1.join(',')
                search_keywords.out = search_keywordsOut1.join(',')
                this.search_keywords = JSON.stringify(search_keywords)
                this.searchOptions = {};
            }else{
                this.search_keywords = '';
                this.searchOptions = {};
            }
            // if(e.key_words == undefined){
            //     e.key_words = ''
            // }
            // this.search_keywords = e;
            this.page.pageIndex = 1;
            this.getList();
        },
        newSearch(e) {
            console.log(7654,e)
            this.isAdvanced = true;
            let keySearch = {};
            this.searchOptions = {};
            this.search_keywords = e;
            this.page.pageIndex = 1;
            let search_keywords = e;
            let search_keywordsIn = JSON.parse(search_keywords).in
            let search_keywordsOut = JSON.parse(search_keywords).out
            search_keywordsIn = search_keywordsIn.split(',')
            search_keywordsOut = search_keywordsOut.split(',')
            let arr = []
            search_keywordsIn.forEach(el => {
                arr.push({
                    key_words: el
                })
            })
            keySearch.in = arr
            keySearch.out = search_keywordsOut
            this.saveSearch = JSON.stringify(keySearch)
            console.log(this.saveSearch)
            this.keySearch = keySearch;
            this.getList();
        },
        keywordChange(e) {
            this.isAdvanced = false;
            let keySearch = {};
            this.search_keywords = ''
            if(e.key_words == undefined){
                e.key_words = ''
            }
            this.searchOptions = e;
            this.page.pageIndex = 1;
            let search_keywordsIn = []
            let search_keywordsOut = []
            search_keywordsIn.push(e)
            keySearch.in = search_keywordsIn
            keySearch.out = search_keywordsOut
            this.saveSearch = ''
            this.keySearch = keySearch
            this.getList();
            // console.log(e)
        },
        getFilters(e) {
            this.filterOptions = e;
            this.page.pageIndex = 1;
            this.getList();
            console.log(e)
        },
        setIsSelectAll(e) {
            this.isSelectAll = e;
        },
        getList() {
            this.waiting = true;
            let data = {
                page: this.page.pageIndex,
                pagesize: this.page.pageSize,
                page_type: this.pageType
            };
            this.loading = true;
            Object.assign(data, this.searchOptions);
            Object.assign(data, this.filterOptions);
            data.search_keywords = this.search_keywords;
            common.myFetch(apis.Index_search, data).then(res => {
                this.loading = false;
                if (res) {
                    console.log(9999,encodeURI(JSON.stringify(this.filterOptions)))
                    let newQuery = JSON.parse(JSON.stringify(this.$route.query))
                    newQuery.filter = encodeURI(JSON.stringify(this.filterOptions))
                    this.$router.replace({
                        query: newQuery
                    })
                    this.tabList = res.params.tab.option.list;
                    this.list_search = res.params.list_search;
                    if(this.tabList.length > 0 && this.pageType == 'file'){
                        this.pageType = res.params.tab.option.list[0].key
                    }
                    this.empty = ''
                    if(this.page.pageIndex == 1 && res.list == 0 && this.pageType == "file"){
                        this.empty = '素材'
                    }else if(this.page.pageIndex == 1 && res.list == 0 && this.pageType == "material"){
                        this.empty = '线索'
                    }
                    res.list.forEach(el => {
                        el.isSelected = false;
                        el.isOn = false;
                        el.showMenu = false;
                        el.showLeft = false;
                    })
                    this.pageType == "file"
                        ? (this.mList = res.list)
                        : (this.clueList = res.list);
                    this.show_list = res.show_list;
                    this.$set(
                        this.page,
                        "pageCount",
                        common.calculatePage(res.page.row_count - 0, this.page.pageSize)
                    );
                    this.$set(this.page, "total", res.page.row_count - 0);
                    this.$refs.headline.passFilterData(res.params.top_search.option.list)
                    this.$nextTick(() => {
                        if(this.firstShow){
                            setTimeout(() => {
                                let keySearch = {}
                                let search_keywordsIn = []
                                let search_keywordsOut = []
                                if(this.$route.query.k){
                                    search_keywordsIn.push({
                                        search_option: this.$route.query.t || 0,
                                        key_words: this.$route.query.k || ''
                                    })
                                }
                                keySearch.in = search_keywordsIn
                                keySearch.on = search_keywordsOut
                                this.keySearch = keySearch
                            }, 300)
                        }
                        this.waiting = false;
                        this.firstShow = false;
                    })
                }
            });
        },
        switchSort(i) {
            // 切换筛选
            if (i.selected) return;

            this.sorts.forEach(s => {
                this.$set(s, "selected", false);
            });

            this.$set(i, "selected", true);
            this.filterOptions["sort_by"] = i.key;
            this.getList();
        }
    },
    mounted() {
        const path = this.$route.path.split('/')[1]
        this.path = path;
        this.pageType = this.$route.query.m || 'file'
        this.filterOptions = this.$route.query.filter && JSON.parse(decodeURI(this.$route.query.filter)) || {}
        this.selectListNum = this.$store.state.selectList.length
        this.searchOptions = {
            search_option: this.$route.query.t || 0,
            key_words: this.$route.query.k || ''
        }
        this.getList()
    }
}
</script>

<style src="../../assets/css/filter/index.less" lang="less" scoped></style>
<style>
    .filter-container .clueFilter{
        box-shadow: none;
        border-radius: 0;
        padding: 25px 36px 0;
        box-sizing: border-box;
    }
</style>